<template>
  <div>
<!--    <div style=" font-size: 18px;padding-bottom: 20px;text-align: center;">揽收时间</div>-->
    <a-form-model :data="thisForm" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" align="center">
      <a-form-model-item label="物流名称">
        <div style="">{{thisForm.name}}</div>
      </a-form-model-item>
      <a-form-model-item label="揽收日期" :colon="false">
        <a-select v-model="thisForm.collectDate" placeholder="请选择处理状态" clearable style="width: 200px">
          <a-select-option
            v-for="item in collectDateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="揽收时间">
        <a-time-picker style="width: 200px" v-model="thisForm.collectTime" auto-complete="off" placeholder="请输入揽收时间"
                       value-format="HH:mm:ss" format="HH:mm:ss"></a-time-picker>
      </a-form-model-item>
      <a-form-model-item label="最大时限">
        <a-input style="width: 200px" v-model="thisForm.sendTime" placeholder="请输入发货最大时限"></a-input>
      </a-form-model-item>
      <!--    <a-form-model-item>-->
      <!--      <a-row>-->
      <!--        <a-button @click="submit">修改</a-button>-->
      <!--      </a-row>-->

      <!--    </a-form-model-item>-->
    </a-form-model>
  </div>
</template>

<script>
import {updateCollectTime} from "../../../api/express";

export default {
  name: "LogisticsEdit",
  props: {
    form: Object,
    onSaveHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      thisForm: {},
      collectDateOptions:[{
        label: "当日",
        value: "0"
      },{
        label: "次日",
        value: "1"
      }]
    }
  },
  mounted() {
    this.thisForm = this.form;
    console.log(this.thisForm)
  },
  methods: {
    async submit() {
      const res = await updateCollectTime(this.thisForm);
      if (res.code === 1200) {
        // this.$message({
        //   message: '更新成功',
        //   type: 'success',
        // });
        this.$message.success("修改成功")
        // this.onCancelHandler();
      }
    }
  }
}
</script>

<style scoped>

</style>
